<template>
  <svg
    id="Capa_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 422.555 422.555"
    style="enable-background: new 0 0 422.555 422.555"
    xml:space="preserve"
    @click="$emit('click')"
  >
    <g>
      <path
        d="M419.061,11.643c-2.223-2.127-5.45-3.139-9.544-3.139c-32.927,0-122.005,65.392-196.859,141.77
      c-42.696,43.557-64.478,74.066-72.961,96.074c6.455,2.162,13.001,5.199,19.671,9.167c5.219,3.105,10.092,6.77,14.468,10.88
      c0.006,0.002,0.008,0.004,0.014,0.006c8.528,8.007,14.971,17.444,19.188,27.578c21.773-9.709,51.271-32.1,92.405-74.059
      C369.608,134.048,439.164,30.877,419.061,11.643z"
      />
      <path
        d="M150.175,266.736c-11.455-6.818-22.257-10.794-32.808-12.057c-2.466-0.295-4.918-0.443-7.361-0.443
      c-8.065,0-16.189,1.62-24.149,4.817c-30.825,12.389-33.835,41.568-36.491,67.315c-3.306,32.045-6.979,52.036-39.43,58.957
      c-5.942,1.268-10.125,6.608-9.93,12.682c0.195,6.074,4.711,11.136,10.723,12.02c18.16,2.67,35.401,4.023,51.246,4.024
      c0.004,0,0.007,0,0.011,0c34.558,0,63.052-6.296,84.689-18.712c19.855-11.393,33.144-27.572,38.43-46.788
      c2.911-10.582,3.135-21.488,1.005-31.951C182.025,296.534,169.276,278.103,150.175,266.736z"
      />
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "ThemeIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
